import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MomentDatePipe } from '@mitsubishi/shared/ui';

import { NewsImgComponent } from '../news-img/news-img.component';
import { NewsDetailCardComponent } from './news-detail-card.component';

@NgModule({
  declarations: [NewsDetailCardComponent],
  imports: [CommonModule, MomentDatePipe, NewsImgComponent],
  exports: [NewsDetailCardComponent],
})
export class NewsDetailCardModule {}
